<template>
  <div class="magazine-footer">
    <div class="magazine-footer-container">
      <div class="magazine-footer-title">
        <slot name="title" />
      </div>
      <div class="magazine-footer-description">
        <slot name="description" />
      </div>
      <div class="magazine-footer-print">
        <div
          v-for="(printCard, i) in localPdfList"
          :key="i"
          class="magazine-footer-print-card"
        >
          <print-card :pdf="printCard" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PrintCard from './PrintCard'

export default {
  name: 'SanitasMagazineFooter',
  components: { PrintCard },
  props: {
    pdfList: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localPdfList: [],
    }
  },
  mounted() {
    if (this.pdfList) {
      this.localPdfList = JSON.parse(this.pdfList)
    }
  },
}
</script>

<style lang="postcss" scoped>
.magazine-footer {
  background-color: var(--c-primary-color-1);
  padding: 80px 0;
  display: flex;
  sup {
    top: -0.2em !important;
  }
  &-container {
    width: 100%;
    max-width: 1100px;
    margin: auto;
  }
  &-title {
    font-family: 'Faustina', serif;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0.4px;
    color: var(--c-primary-neutral-3);
    padding: 20px 20px 20px 0;
    line-height: normal;
  }
  &-description {
    font-size: 15px;
    letter-spacing: 0.4px;
    color: var(--c-primary-neutral-3);
    max-width: 540px;
    line-height: normal;
  }
  &-print {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding-top: 20px;
    &-card {
      width: calc((100% - 60px) / 4);
      margin-right: 20px;
      padding-bottom: 10px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

@media (max-width: 1200px) {
  .magazine-footer {
    padding: 80px 30px;
    width: 100%;
    margin-left: 0;
    margin-right: 0;
  }
}
@media (max-width: 1099px) {
  .magazine-footer {
    &-print {
      &-card {
        width: calc((100% - 36px) / 4);
        margin-right: 12px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
@media (max-width: 490px) {
  .magazine-footer {
    padding: 20px 10px;
    height: auto;
    &-print {
      &-card {
        width: calc(50% - 6px);
        &:nth-child(even) {
          margin-right: 0;
        }
      }
    }
    &-title,
    &-description,
    &-print {
      padding: 10px 0;
    }
  }
}
</style>
